import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { IoDuplicate, IoEye } from 'react-icons/io5'
import { Funcoes } from '../../Utils/Funcoes'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, Produto, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ThemeProvider, createTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ProdutoService } from '../../Pages/Products/ProdutoService'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { FaTrashAlt } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { RiEdit2Fill } from 'react-icons/ri'
import moment from 'moment'

type Props = {
    produto: Produto[],
    handleUpdateProdutosList: () => void,
}

interface Grupo {
    id: number
    description: string
}

interface Marca {
    id: number
    description: string
}

interface SubGrupo {
    id: number
    description: string
}

interface UnidMedida {
    id: number
    description: string
}

interface Tributação {
    id: number
    descricao: string
}

interface RowData {
    id: number,
    descricao: string,
    cod_barra: string,
    referencia: string,
    preco_v: number,
    estoque_fisico: number,
    id_empresa: number,
    id_grupo: Grupo,
    id_marca: Marca,
    id_sgrupo: SubGrupo,
    id_tributacao: Tributação,
    id_unid_medida: UnidMedida,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,
    dt_cadastro: string,
    dt_last_update?: string,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    preco_c: number,
    peso: number,
    estoque_minimo: number,
    ativo: string,
    ncm: string,
    cod_cest: string,
    origem_mercadoria: string,
    tipo: string,
    estoque: number,
    urlImage: string,
    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

type TipoMap = {
    [key: string]: string
}

type VisibilityState = Record<string, boolean>

export const GridProducts = React.memo(({ produto, handleUpdateProdutosList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_produto")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_produto") || '')
                : {
                    acao: true,
                    descricao: true,
                    cod_barra: true,
                    referencia: true,
                    preco_v: true,
                    estoque_fisico: true,
                    descGrupo: false,
                    descSubGrupo: false,
                    descMarca: false,
                    descUnidMedida: false,
                    preco_c: false,
                    peso: false,
                    descTributacao: false,
                    estoque: false,
                    ncm: false,
                    cod_cest: false,
                    tipo: false,
                    ativo: false,
                    estoque_minimo: false,
                    origem_mercadoria: false,
                    dt_cadastro: false
                }
        )
    }, [])

    const [idProd, setIdProd] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [produtos, setProdutos] = useState<Produto[]>([])
    const [nomeProduto, setNomeProduto] = useState("")

    //const [modal_dados_produto_visible, setModal_Dados_Produto_Visible] = useState(false)

    let user = useSelector(state => selectUser(state))


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setProdutos(produto)
    }, [produto])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_produto", JSON.stringify(columnVisibility))
    }, [columnVisibility])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await ProdutoService.Delete(idProd, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Produto excluído com sucesso`)

                handleUpdateProdutosList()

                //setProdutos(await ProdutoService.Filter('', '', ''))
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {

            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir o produto. Por favor, tente novamente`)
        }

    }, [idProd])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_produto")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeProduto("")
        }

    }, [alertType])


    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeProduto("")
    }, [])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },

        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- CODIGO SEM USO -----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    /*
    const abrirModalDadosProduto = () => {
        //setModal_Dados_Produto_Visible(true)
    }

    const fecharModalDadosProduto = () => {
        //setModal_Dados_Produto_Visible(false)
    }
    */

    /*
    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.acao = json.acao
                newColumnVisibility.descricao = json.descricao
                newColumnVisibility.cod_barra = json.cod_barra
                newColumnVisibility.referencia = json.referencia
                newColumnVisibility.descGrupo = json.descGrupo
                newColumnVisibility.descSubGrupo = json.descSubGrupo
                newColumnVisibility.descMarca = json.descMarca
                newColumnVisibility.descUnidMedida = json.descUnidMedida
                newColumnVisibility.preco_c = json.preco_c
                newColumnVisibility.preco_v = json.preco_v
                newColumnVisibility.peso = json.peso
                newColumnVisibility.descTributacao = json.descTributacao
                newColumnVisibility.estoque = json.estoque
                newColumnVisibility.estoque_fisico = json.estoque_fisico
                newColumnVisibility.ncm = json.ncm
                newColumnVisibility.cod_cest = json.cod_cest
                newColumnVisibility.tipo = json.tipo
                newColumnVisibility.ativo = json.ativo
                newColumnVisibility.estoque_minimo = json.estoque_minimo
                newColumnVisibility.origem_mercadoria = json.origem_mercadoria
                newColumnVisibility.dt_cadastro = json.dt_cadastro
            }
        }

    }, [])
    
   
    */

    /*
    const AcoesCell = React.memo(function AcoesCellComponent({ row }: { row: RowData }) {
        const handleExcluirClick = () => {
            setIdProd(row.id)
            setModalShow(!modalShow)
        }

        const navegacao = () => {
            navegarTelaProdutoEdit(row.id)
        }

        const navegacaoDupli = () => {
            navegarTelaProdutoDup(row.id)
        }

        const modalProduto = () => {
            setIdProd(row.id)
            abrirModalDadosProduto()
        }


        return (
            <div className='flex justify-start w-full'>

                <button
                    data-tooltip-id={'tooltip-vis-1'} id={'btn-vis-1'}
                    onClick={modalProduto}
                    className='flex items-center justify-center text-white transition-all duration-300 hover:bg-slate-600 w-[30px] h-[30px] rounded-md bg-slate-500'>
                    <IoEye size={'20px'} />
                    <Tooltip style={{ backgroundColor: 'rgb(100 116 139)' }} id={'tooltip-vis-1'}
                        anchorSelect={'#btn-vis-1'} positionStrategy="fixed" place='top-start'  >
                        <span className={`font-sans font-medium text-[13px]`}>Visualizar</span>
                    </Tooltip>
                </button>

                <button 
                data-tooltip-id={'tooltip-duplicar-1'} id={'btn-duplicar-1'}
                    onClick={navegacaoDupli}
                    className='flex items-center justify-center 
                                    text-white transition-all duration-300 
                                    hover:bg-slate-600 dark:hover:bg-slate-700 w-[30px] h-[30px] rounded-md 
                                    bg-slate-500 dark:bg-slate-400 ml-2'>
                    <IoDuplicate size="18px" />
                    <Tooltip style={{ backgroundColor: 'rgb(148, 163, 184)' }} id={'tooltip-duplicar-1'}
                        anchorSelect={'#btn-duplicar-1'} positionStrategy="fixed" place='top-start'  >
                        <span className={`font-sans font-medium text-[13px]`}>Duplicar</span>
                    </Tooltip>
                </button>

                <button
                    data-tooltip-id={'tooltip-editar-1'} id={'btn-editar-1'}
                    onClick={navegacao}
                    className='flex items-center justify-center text-white transition-all duration-300 hover:bg-sky-600 w-[30px] h-[30px] rounded-md bg-sky-500 ml-2'>
                    <RiEdit2Fill size="20px" />
                    <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-1'}
                        anchorSelect={'#btn-editar-1'} positionStrategy="fixed" place='top-start'  >
                        <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                    </Tooltip>
                </button>

                <button
                    onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-1'} id={'btn-excluir-1'}
                    className={`flex items-center justify-center 
                                text-white transition-all duration-300 
                                hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                bg-red-500 ml-2`} >
                    <FaTrashAlt size="18px" />
                    <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-1'}
                        anchorSelect={'#btn-excluir-1'} positionStrategy="fixed"  >
                        <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                    </Tooltip>
                </button>

            </div>
        )
    })

    const DescCell = React.memo(function DescCellComponent({ row }: { row: RowData }) {
        return <span>{row.descricao ? row.descricao : <span className='text-red-400'>N/D</span>}</span>
    })

    const CodBarrasCell = React.memo(function CodBarrasCellComponent({ row }: { row: RowData }) {
        return (
            <span>
                {row.cod_barra ? row.cod_barra : <span className='text-red-400'>N/D</span>}
            </span>
        )
    })

    const RefCell = React.memo(function RefCellComponent({ row }: { row: RowData }) {
        return (
            <span>
                {row.referencia ? row.referencia : <span className='text-red-400'>N/D</span>}
            </span>
        )
    })

    const PrecoVendaCell = React.memo(function PrecoVendaCellComponent({ row }: { row: RowData }) {
        return (
            <span>
                {row.preco_v ? Funcoes.numberFormat(row.preco_v,  'currency') : <span className='text-red-400'>N/D</span>}
            </span>
        )
    })

    const EstoqueFisCell = React.memo(function EstoqueFisCellComponent({ row }: { row: RowData }) {
        return (
            <span>
                {row.estoque_fisico ? Funcoes.numberFormat(row.estoque_fisico, 'decimal') : <span className='text-red-400'>N/D</span>}
            </span>
        )
    })
    */

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaProdutoEdit = (id: number) => {
        navigate(`/produtos/edit/${id}`)
    }

    const navegarTelaProdutoDup = (id: number) => {
        navigate(`/produtos/dupli/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const tipoAtivoMap: TipoMap = {
        'S': 'Sim',
        'N': 'Não',
    }

    function mapTipoAtivo(ativo: string) {
        return (
            <>
                {tipoAtivoMap[ativo] || <div className='text-red-400'>N/D</div>}
            </>
        )

    }

    const tipoProdutoMap: TipoMap = {
        'P': 'Produto Para Revenda',
        'M': 'Matéria Prima',
        'S': 'Serviço'
    }

    function mapTipoProduto(tipo: string) {
        return (
            <>
                {tipoProdutoMap[tipo] || <div className='text-red-400'>N/D</div>}
            </>
        )
    }

    const tipoOrigemMap: TipoMap = {
        '0': 'Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8.',
        '1': 'Estrangeira – Importação direta, exceto a indicada no código 6',
        '2': 'Estrangeira – Adquirida no mercado interno, exceto a indicada no código 7.',
        '3': 'Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento).',
        '4': 'Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos (PPB) de que tratam o Decreto-Lei nº 288/1967,  e as Leis nºs 8.248/1991, 8.387/1991, 10.176/2001 e 11.484/2007.',
        '5': 'Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento).',
        '6': 'Estrangeira – Importação direta, sem similar nacional, constante em lista de Resolução CAMEX e gás natural.',
        '7': 'Estrangeira – Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX e gás natural.',
        '8': 'Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70% (setenta por cento).',
    }

    function mapTipoOrigem(origem: string) {
        return (
            <>
                {tipoOrigemMap[origem] || <div className='text-red-400'>N/D</div>}
            </>
        )
    }

    const colunas = useMemo<MRT_ColumnDef<Produto>[]>(() => [

        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData
                
                const navegarDup = () => {
                    navegarTelaProdutoDup(rowData.id)
                }
                
                const navegarEdit = () => {
                    navegarTelaProdutoEdit(rowData.id)
                }
                
                const handleExcluirClick = () => {

                  const timerExcluir =  setTimeout(() => {
                        setIdProd(rowData.id)
                        setNomeProduto(rowData.descricao)
                        setModalShow(true)

                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }
    
                        let menuFiltro = document.getElementById("divMenuFiltroProd") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsProd") as HTMLDivElement
                        let bodySearchMarca = document.getElementById("bodySearchBox-marca") as HTMLDivElement
                        let bodySearchGrupo = document.getElementById("bodySearchBox-grupo") as HTMLDivElement
                        let bodySearchSubGrupo = document.getElementById("bodySearchBox-subGrupo") as HTMLDivElement
                        let bodySearchTrib = document.getElementById("bodySearchBox-tributacao") as HTMLDivElement
    
                        if (menuFiltro) {
    
                            bodySearchMarca.classList.remove("visible")
                            bodySearchGrupo.classList.remove("visible")
                            bodySearchSubGrupo.classList.remove("visible")
                            bodySearchTrib.classList.remove("visible")
    
                            menuInputs.classList.add("invisible")
    
                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[1100px]")
                                menuFiltro.classList.add("max-h-[0px]")
    
                                Inputfocus()
                                clearTimeout(timer)
                            }, 100)
                        }
                        clearTimeout(timerExcluir)
                    }, 0)
                    
                }

                return (

                    <>
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegarDup} data-tooltip-id={'tooltip-dupli-' + rowData.id} id={'btn-dupli-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-slate-700 w-[30px] h-[30px] rounded-md 
                                          bg-slate-400`}>
                                <IoDuplicate size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(51 65 85)' }} id={'tooltip-dupli-' + rowData.id} anchorSelect={'#btn-dupli-' + rowData.id} positionStrategy="fixed" place='top-start'>
                                    <span className={`font-sans font-medium text-[13px]`}>Duplicar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={navegarEdit} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500 ml-2`}>
                                <RiEdit2Fill size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'>
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />
                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed" place='top-end'>
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    </>

                )
            }
        },

        {
            accessorKey: 'descricao', visibleInShowHideMenu: true, header: 'Descrição', size: 400, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.descricao ? rowData.descricao : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'cod_barra', visibleInShowHideMenu: true, header: 'Código de Barras', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cod_barra ? rowData.cod_barra : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'referencia', visibleInShowHideMenu: true, header: 'Referência', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.referencia ? rowData.referencia : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'preco_c', visibleInShowHideMenu: true, header: 'Preço de Custo (R$)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.preco_c ? Funcoes.numberFormat(rowData.preco_c, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'preco_v', visibleInShowHideMenu: true, header: 'Preço de Venda (R$)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.preco_v ? Funcoes.numberFormat(rowData.preco_v, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'estoque', visibleInShowHideMenu: true, header: 'Estoque ', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.estoque ? Funcoes.numberFormat(rowData.estoque, 'decimal') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'estoque_fisico', visibleInShowHideMenu: true, header: 'Estoque Físico', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.estoque_fisico ? Funcoes.numberFormat(rowData.estoque_fisico, 'decimal') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'estoque_minimo', visibleInShowHideMenu: true, header: 'Estoque Mínimo', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.estoque_minimo ? Funcoes.numberFormat(rowData.estoque_minimo, 'decimal') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'descGrupo', visibleInShowHideMenu: true, header: 'Grupo', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id_grupo.description ? rowData.id_grupo.description : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'descSubGrupo', visibleInShowHideMenu: true, header: 'SubGrupo', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id_sgrupo.description ? rowData.id_sgrupo.description : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'descMarca', visibleInShowHideMenu: true, header: 'Marca', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id_marca.description ? rowData.id_marca.description : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'descUnidMedida', visibleInShowHideMenu: true, header: 'Unidade de Medida', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id_unid_medida.description ? rowData.id_unid_medida.description : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'peso', visibleInShowHideMenu: true, header: 'Peso (KG)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.peso ? Funcoes.numberFormat(rowData.peso, 'decimal') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'descTributacao', visibleInShowHideMenu: true, header: 'Tributação', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id_tributacao.descricao ? rowData.id_tributacao.descricao : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'ncm', visibleInShowHideMenu: true, header: 'NCM', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.ncm ? rowData.ncm : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'cod_cest', visibleInShowHideMenu: true, header: 'Código Cest', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cod_cest ? rowData.cod_cest : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'tipo', visibleInShowHideMenu: true, header: 'Tipo de Produto', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData
                const tipoProduto: string = rowData.tipo

                return mapTipoProduto(tipoProduto)
            }

        },

        {
            accessorKey: 'ativo', visibleInShowHideMenu: true, header: 'Ativo', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData
                const tipoAtivo: string = rowData.ativo

                return mapTipoAtivo(tipoAtivo)
            }
        },

        {
            accessorKey: 'origem_mercadoria', visibleInShowHideMenu: true, header: 'Origem', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData
                const tipoOrigem: string = rowData.origem_mercadoria

                return mapTipoOrigem(tipoOrigem)
            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

    ], [])

    const table = useMaterialReactTable({
        columns: colunas,
        data: produtos,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>
            <ThemeProvider theme={theme} >

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir o produto - ${nomeProduto || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )
})